import { app } from '../../../../../app';
import { Controller } from './hotp-totp-add.controller';

app.component('addHotpTotpTokens', {
    controller: Controller,
    templateUrl: require('./hotp-totp-add.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-add/hotp-totp-add/hotp-totp-add.component.js